export default __webpack_public_path__ + "static/media/NBP.94f79342.png";